//@flow
import * as React from 'react';
import { ErrorScreen } from 'common/components/core/errors/ErrorScreen';
import { Text, Button, Stack, Columns, Box } from '@locus-taxy/neo-ui';
import testIds from 'common/tests/core/coreIds.json';
import variables from 'common/components/core/variables.scss';

type Props = {
    maxContentWidth?: number,
    onActionClick?: () => void,
    actionLabel?: string,
    onSecondaryActionClick?: () => void,
    secondaryActionLabel?: string,
    statusCode?: number,
    imageSrc?: string,
    subtitle?: string,
    message?: string,
    renderErrorIcon?: () => void,
    containerStyles?: Object,
    actionIcon?: string
};

class APIErrorScreen extends React.Component<Props> {
    static defaultProps = {
        maxContentWidth: 600,
        containerStyles: {}
    };
    render() {
        const {
            maxContentWidth,
            onActionClick,
            actionLabel,
            onSecondaryActionClick,
            secondaryActionLabel,
            statusCode,
            message,
            subtitle,
            actionIcon,
            imageSrc,
            containerStyles,
            renderErrorIcon,
            ...others
        } = this.props;
        return (
            <ErrorScreen {...others} maxContentWidth={maxContentWidth}>
                {() => {
                    return (
                        <Box
                            maxWidth={600}
                            marginX="auto"
                            paddingTop={variables.appbarHeight}
                            {...containerStyles}
                        >
                            <Stack space="xxLarge" align="center">
                                {imageSrc ? <img src={imageSrc} /> : null}
                                {renderErrorIcon ? renderErrorIcon() : null}
                                {statusCode ? (
                                    <Text
                                        fontSize="140px"
                                        lineHeight={0.8}
                                        data-test-id={
                                            testIds.apiErrorScreen.statusCode
                                        }
                                    >
                                        {statusCode}
                                    </Text>
                                ) : null}
                                {message ? (
                                    <Text
                                        textAlign="center"
                                        fontSize={5}
                                        data-test-id={
                                            testIds.apiErrorScreen.message
                                        }
                                    >
                                        {message}
                                    </Text>
                                ) : null}
                                {subtitle ? (
                                    <Text
                                        textAlign="center"
                                        fontSize={4}
                                        data-test-id={
                                            testIds.apiErrorScreen.subtitle
                                        }
                                    >
                                        {subtitle}
                                    </Text>
                                ) : null}
                                <Columns space="medium">
                                    {actionLabel ? (
                                        <Button
                                            appearance="solid"
                                            palette="primary"
                                            onClick={onActionClick}
                                            icon={
                                                actionIcon ? actionIcon : null
                                            }
                                            data-test-id={
                                                testIds.apiErrorScreen.actionBtn
                                                    .primary
                                            }
                                        >
                                            {actionLabel}
                                        </Button>
                                    ) : null}
                                    {onSecondaryActionClick ? (
                                        <Button
                                            appearance="outline"
                                            palette="neutral"
                                            onClick={onSecondaryActionClick}
                                            data-test-id={
                                                testIds.apiErrorScreen.actionBtn
                                                    .secondary
                                            }
                                        >
                                            {secondaryActionLabel}
                                        </Button>
                                    ) : null}
                                </Columns>
                            </Stack>
                        </Box>
                    );
                }}
            </ErrorScreen>
        );
    }
}

export default APIErrorScreen;
export { APIErrorScreen };
